<template>
  <footer class="bg-primary text-white w-full mt-auto mb-0">
    <!-- Main Footer -->
    <section class="section sm:pb-6 lg:pb-14 container-padding w-full max-w-screen-xl mx-auto">
      <div class="flex flex-col sm:flex-row justify-center md:justify-between gap-6 sm:gap-12 md:gap-10 lg:gap-12">
        <!-- Left / Logo col -->
        <img
          loading="lazy"
          src="@/assets/images/global/app-footer/sportpix-logo-icon.svg"
          class="block w-full max-w-20 md:max-w-28 flex-shrink-0 md:m-auto"
          alt="SportPix Logo"
        >

        <!-- Right col -->
        <div class="flex flex-col lg:flex-row justify-between items-center gap-6 md:gap-12 2xl:gap-20">
          <ul class="footer-menu grid grid-cols-2 sm:grid-cols-3 gap-x-6 md:gap-x-8 lg:gap-x-12 gap-y-2.5 lg:gap-y-1.5 list-none m-0 w-full">
            <li
              v-for="(link, index) in footerLinks"
              :key="index"
              class="col-span-1 sm:text-left"
            >
              <AppLink
                :to="link.to"
                class="footer-menu link md:text-sm xl:text-[15px]"
              >
                {{ link.name }}
              </AppLink>
            </li>
          </ul>

          <ul class="hidden flex-wrap sm:justify-center lg:grid grid-cols-3 md:gap-x-4 lg:gap-x-6 gap-y-6 md:gap-y-8 list-none m-0">
            <li
              v-for="(link, index) in externalLinks"
              :key="index"
              class="flex justify-center items-center"
            >
              <img
                loading="lazy"
                :src="link.image"
                class="block md:max-h-6 lg:max-h-12 h-auto w-auto lg:min-w-14 opacity-60 object-cover"
                :alt="`${link.name} logo`"
              >
              <span class="sr-only">{{ link.name }}</span>
            </li>
          </ul>
        </div>
      </div>

      <ul class="lg:hidden list-none mx-auto grid sm:flex items-center justify-center grid-cols-3 gap-x-6 gap-y-6 md:gap-y-8 mt-12">
        <li
          v-for="(link, index) in externalLinks"
          :key="index"
          class="flex justify-center items-center"
        >
          <img
            loading="lazy"
            :src="link.image"
            class="block max-h-6 xs:h-auto w-auto opacity-60 object-cover cursor-auto"
            :alt="`${link.name} logo`"
          >
          <span class="sr-only">{{ link.name }}</span>
        </li>
      </ul>
    </section>

    <!-- Colophon -->
    <section class="border-t border-white/10">
      <div class="mx-auto max-w-screen-xl">
        <div
          class="text-[10px] sm:text-xs text-white/70 py-2.5 md:py-2 px-8 flex items-center flex-col gap-1 md:flex-row sm:justify-between sm:gap-0"
        >
          <span class="sm:text-center">
            Copyright © {{ currentYear }} SportPix
          </span>

          <div class="flex items-center gap-1 whitespace-nowrap">
            <img
              loading="lazy"
              :src="CreationLabsLogo"
              class="block w-auto h-5"
              alt="Secure Eft Logo"
            >
            Designed and developed by
            <AppLink
              to="https://creationlabs.co.za/"
              class="font-semibold"
            >
              Creation Labs Software
            </AppLink>
          </div>
        </div>
      </div>
    </section>

    <!--Back to top button for mobile-->
    <ScrollToTopButton />
  </footer>
</template>

<script setup>
import {
  CreationLabsLogo,
  MastercardLogo,
  PayfastLogo,
  SecureEftLogo,
  SnapScanLogo,
  VisaLogo,
  ZapperLogo,
} from '@/assets/images/global/app-footer';

import { AppLink } from '@/components/app';
import { ScrollToTopButton } from '@/components/buttons';

import { useRoute } from 'vue-router';

const route = useRoute();

const currentYear = new Date().getFullYear();

const footerLinks = [
  { name: 'Home', to: { name: 'app_event_list' } },
  { name: 'Privacy Policy', to: { name: 'app_privacy_policy' } },
  { name: 'About Us', to: { name: 'app_about_us' } },
  { name: 'For Event Organisers', to: { name: 'app_for_event_organisers' } },
  { name: 'Terms of Use', to: { name: 'app_terms_of_use' } },
  { name: 'For Photographers', to: { name: 'app_for_photographers' } },
  { name: 'Contact Us', to: { name: 'app_contact_us' } },
  { name: 'FAQs', to: { name: 'app_faqs' } },
];

const externalLinks = [
  { name: 'VISA', image: VisaLogo },
  { name: 'SpanScan', image: SnapScanLogo },
  { name: 'Zapper', image: ZapperLogo },
  { name: 'PayFast', image: PayfastLogo },
  { name: 'Mastercard', image: MastercardLogo },
  { name: 'SiD Secure EFT', image: SecureEftLogo },
];
</script>
